import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import { get } from '#utilities/js/ea/ajax.js'
import href from '#utilities/js/ea/href.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: async (
    button
  ) => {
    const { dataset } = button
    const { scopeJson } = dataset
    const json = JSON.parse(scopeJson)

    const url = href('space/req_registrar_add', {
      action: json.action ?? null,
      delete: true,
      domain : json.domain ?? null,
      space: json.space ?? null,
    })

    try {
      await get(url, { target: button })
    } catch (e) {
      console.error(e)
    }

  }
})

export default del => {
  onClick.listen(del)
}
